<template>
  <div class="box">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="card_wrap">
      <h5>{{ language("productDetails.title2") }}</h5>
      <div class="card">
        <div class="status">
          <status-card
            :dataArr="productStatus"
            labelWidth="0px"
            :title="language('productDetails.queryStatus')"
            @change="formChange1"
          ></status-card>
        </div>

        <div class="status">
          <status-card
            :dataArr="onlineStatus"
            labelWidth="0px"
            :title="language('productDetails.onlineStatus')"
            @change="formChange2"
          ></status-card>
        </div>

        <div class="status">
          <!-- labelWidth="150px" -->
          <status-card
            :dataArr="productType"
            labelWidth="0px"
            :title="language('productDetails.productType')"
            @change="formChange3"
          ></status-card>
        </div>

        <div class="input">
          <input-card
            :title="language('productDetails.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="formChange4"
          ></input-card>
        </div>
      </div>
      <div class="button_wrap">
        <el-button type="primary" @click="search">{{
          language("productDetails.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap" v-loading="loading">
      <div class="count">
        <div>
          {{ language("productDetails.results") }}: {{ results }}
          {{ language("productDetails.rows") }}
        </div>
        <div>
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>
      <div class="button_wrap">
        <div class="button_wrap download" v-if="$menuList['SIS-Product-Package-Info-Add']">
          <div class="title">{{ language("productDetails.action") }}</div>
          <el-button type="primary" @click="add">{{
            language("setDetails.add")
          }}</el-button>
        </div>
        <template v-if="$menuList['SIS-Product-Package-Info-Edit']">
          <div class="button_wrap download">
            <div class="title">
              {{ language("productDetails.otherHandling") }}
            </div>
            <el-button type="primary" @click="changeStatus(1)">{{
              language("productDetails.online")
            }}</el-button>
            <el-button type="primary" @click="changeStatus(0)">{{
              language("productDetails.offline")
            }}</el-button>
            <el-button type="primary" @click="changeStatus(2)">{{
              language("productDetails.invisbile")
            }}</el-button>
          </div>
        </template>
      </div>
      <div class="table">
        <cc-table
          :loadData="false"
          :dataArr="dataArr"
          :config="table"
          :params="params"
          :refeshParams="refeshTable"
          :emptyText="language('productDetails.emptyText')"
          @selecting-result="selectingResult"
          :showIndex="false"
          :buttonsWidth="65"
        ></cc-table>
      </div>
    </div>

    <!--商品編輯--->
    <el-dialog
      :close-on-click-modal="false"
      :title="language('productDetails.edit')"
      :visible.sync="dialog"
      width="90%"
      append-to-body
    >
      <template v-if="dialog">
        <edit-package-product
          :editData="editData"
          @success="success"
        ></edit-package-product>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import inputCard from "../../components/inputCard";
import page from "../../components/page";
import editPackageProduct from "./components/editPackageProduct";
import batch from "./components/batch";
export default {
  components: {
    breadcrumb,
    statusCard,
    inputCard,
    page,
    editPackageProduct,
    batch,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("productDetails.breadcrumbTitle2"),
        list: [
          {
            name: this.language("productDetails.breadcrumbList_1"),
          },
          {
            name: this.language("productDetails.breadcrumbList_2_1"),
          },
        ],
      },
      productStatus: [
        {
          title: " ",
          checkbox: [],
          list: [
            {
              name: this.language("productDetails.submit"),
              apiName: "auditStatus",
              value: "0",
            },
            {
              name: this.language("productDetails.approved"),
              apiName: "auditStatus",
              value: "1",
            },
            {
              name: this.language("productDetails.rejected"),
              apiName: "auditStatus",
              value: "2",
            },
            // {
            //   name: this.language("productDetails.hide"),
            //   apiName: "Hide",
            //   value: "Hide",
            // },
          ],
        },
      ],

      onlineStatus: [
        {
          title: " ",
          checkbox: [],
          list: [
            {
              name: this.language("productDetails.online"),
              apiName: "saleStatus",
              value: "1",
            },
            {
              name: this.language("productDetails.offline"),
              apiName: "saleStatus",
              value: "0",
            },
            {
              name: this.language("productDetails.invisible"),
              apiName: "saleStatus",
              value: "2",
            },
          ],
        },
      ],

      productType: [
        {
          // title: this.language("productDetails.oneOfBelow"),
          title: "",
          checkbox: [],
          list: [
            {
              name: this.language("productDetails.book"),
              apiName: "type",
              value: "BOOK",
            },
            {
              name: this.language("productDetails.stat"),
              apiName: "type",
              value: "NONBOOK",
            },
          ],
        },
      ],

      inputArr: [
        // {
        //   name: "SKU ID / Barcode",
        //   apiName: "barcode",
        //   value: "",
        // },
        {
          name: "Model ID",
          apiName: "mchProductId",
          value: "",
        },
        // {
        //   name: "Product Name",
        //   apiName: "name",
        //   value: "",
        // },
      ],

      results: 0,
      dataArr: [],
      params: {},
      refeshTable: -1,
      table: {
        api: "admin/merchant/product/query",
        showPager: false,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        indexFixed: "left",
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            minWidth: 120,
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "Type",
            type: "tag",
            minWidth: 130,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 200,
          },

          {
            prop: "itemSize",
            lable: "Products",
            minWidth: 100,
          },
          {
            prop: "stock",
            lable: "Available Stocks",
            minWidth: 100,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "cover",
            lable: "Product Cover",
            minWidth: 80,
            type: "img",
            urlPropName: "cover",
            sourceUrlPropName: "cover",
            // imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          // {
          //   prop: "categories",
          //   lable: "Category（System）",
          //   minWidth: 120,
          // },
          // {
          //   prop: "brand",
          //   minWidth: 120,
          //   lable: "Brand",
          // },
          {
            prop: "salePrice",
            lable: "Selling Price(HKD)",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.salePrice * 1, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminName",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [
          {
            name: this.language("productDetails.edit"),
            click: (row, index) => {
              this.edit(row, index);
            },
            check: (row) => {
              if (this.$menuList["SIS-Product-Package-Info-Edit"]) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            name: this.language("setDetails.delete"),
            click: (row, index) => {
              this.delete(row);
            },
            check: (row) => {
              if (row.isAllowDelete == 1 && this.$menuList["SIS-Product-Package-Info-Delete"]) {
                return true;
              } else {
                return false;
              }
            },
          },
        ],
      },
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      dialog: false,
      editData: {},
      ids: [],
    };
  },
  methods: {
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/product/queryPackage?isPackage=1", e)
        .then((res) => {
          this.loading = false;
          this.dataArr = res.rows;
          this.results = res.total;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    formChange1(e) {
      this.form1 = { ...e };
      this.svaeForm(e, this.form2, this.form3, this.form4);
    },
    formChange2(e) {
      this.form2 = { ...e };
      this.svaeForm(this.form1, e, this.form3, this.form4);
    },
    formChange3(e) {
      this.form3 = { ...e };
      this.svaeForm(this.form1, this.form2, e, this.form4);
    },
    formChange4(e) {
      this.form4 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form4, e);
    },
    add() {
      this.dialog = true;
      this.editData = {
        shopNum: this.shopData.shopNum,
        mchProductPackageItems: [],
        isPackage: 1,
      };
    },

    svaeForm(form1, form2, form3, form4) {
      this.form = {
        ...form1,
        ...form2,
        ...form3,
        ...form4,
        // pageSize: 10,
        // pageNo: 1,
      };
    },
    search() {
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.$refs.page.init();
      this.getData(this.form);
    },
    edit(e, index) {
      this.dialog = true;
      this.editData = { ...e };
      // if (this.editData.listPrice) {
      //   this.editData.listPrice = this.editData.listPrice / 100;
      // }
      // if (this.editData.recommendPrice) {
      //   this.editData.recommendPrice = this.editData.recommendPrice / 100;
      // }
      if (this.editData.salePrice) {
        this.editData.salePrice = this.editData.salePrice / 100;
      }
      // if (this.editData.productCost) {
      //   this.editData.productCost = this.editData.productCost / 100;
      // }
    },

    selectingResult(e) {
      let ids = [];
      for (let i = 0; i < e.length; i++) {
        ids.push(e[i].id);
      }
      this.ids = ids;
    },
    changeStatus(status) {
      if (this.ids.length == 0) {
        this.$message.error(this.language("productDetails.chooseProductTips"));
        return false;
      }
      this.$confirm(
        this.language("common.changeTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/product/updateProductPackageSaleStatus",
              { ids: this.ids.join(","), saleStatus: status },
              "GET"
            )
            .then((res) => {
              this.getData(this.form);
              this.$message.success(this.language("productDetails.success"));
              this.ids = [];
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    success() {
      this.getData(this.form);
      this.dialog = false;
    },
    delete(e) {
      this.$confirm(
        this.language("setDetails.deleteTips"),
        this.language("batchAddCard.tips"),
        {
          confirmButtonText: this.language("batchAddCard.confirm"),
          cancelButtonText: this.language("batchAddCard.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do("admin/merchant/product/delete", { id: e.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopBannerForm.success"),
              });
              this.getData(this.form);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    if (!this.$menuList["SIS-Products-ProductInfo-Edit"]) {
      this.table.buttons = [];
    }
    this.shopData = this.$shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    .status {
      flex: 1;
    }
    .status {
      padding-right: 20px;
      flex: 1;
    }
    .input {
      width: 300px;
      flex: 1;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .title {
    margin-right: 10px;
    font-weight: 600;
  }
}
.download {
  margin-right: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .table {
    margin-top: 20px;
  }
}
</style>
